const BulletIcon = ({ color }) => (
  <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.087 9.00002C16.087 13.4423 12.4858 17.0435 8.04348 17.0435C3.60119 17.0435 0 13.4423 0 9.00002C0 4.55773 3.60119 0.956543 8.04348 0.956543C12.4858 0.956543 16.087 4.55773 16.087 9.00002ZM8.04348 16.0435C11.9335 16.0435 15.087 12.89 15.087 9.00002C15.087 5.11002 11.9335 1.95654 8.04348 1.95654C4.15347 1.95654 1 5.11002 1 9.00002C1 12.89 4.15347 16.0435 8.04348 16.0435ZM11.4547 6.36014C11.7841 6.61127 11.8476 7.08188 11.5965 7.41129L7.67843 12.5506L5.11965 9.4801C4.85448 9.1619 4.89747 8.68897 5.21568 8.4238C5.53389 8.15863 6.00681 8.20162 6.27199 8.51983L7.62625 10.1449L10.4036 6.50188C10.6547 6.17247 11.1253 6.10901 11.4547 6.36014Z"
      fill={color}
    />
  </svg>
);

export default BulletIcon;
